<template>
  <div>
    <v-menu v-if="!$vuetify.breakpoint.xs"
            v-model="show"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field v-bind:name="name"
                      v-model="formattedDate"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      :dense="dense"
                      hide-details="auto"
                      :rules="rules"
                      :label="label"
                      :clearable="clearable"
                      prepend-inner-icon="mdi-calendar"
                      :class="fieldClass"
                      style="max-width: 12em; min-width: 10em;"/>
      </template>
      <v-date-picker no-title
                     v-model="date"
                     :min="min"
                     :max="max"
                     :locale="$i18n.locale"
                     @input="show = false"/>
    </v-menu>

    <v-dialog v-if="$vuetify.breakpoint.xs"
              ref="dialog"
              v-model="show"
              :return-value.sync="date"
              width="290px">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field v-bind:name="name"
                      v-model="formattedDate"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      :dense="dense"
                      hide-details="auto"
                      :rules="rules"
                      :label="label"
                      :clearable="clearable"
                      prepend-inner-icon="mdi-calendar"
                      :class="fieldClass"
                      style="max-width: 12em; min-width: 10em;"/>
      </template>
      <v-date-picker v-model="date"
                     scrollable
                     :min="min"
                     :max="max"
                     :locale="$i18n.locale"
                     @click:date="dialogDateSelected">
        <v-spacer/>
        <v-btn text
               color="primary"
               @click="show = false">{{ $t('actions.cancel') }}
        </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'DatePicker',

  props: {
    value: {
      required: true,
    },
    name: {
      type: String,
    },
    min: {},
    max: {},
    rules: {},
    label: {
      type: String,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    fieldClass: {},

  },
  data: () => ({
    show: false,
  }),
  computed: {
    date: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },
    formattedDate: {
      get() {
        return this.$options.filters.date(this.date);
      },
      set(value) {
        //The text field is read only, so this needs to deal only with clearing
        if (!value) {
          this.date = null;
        }
      },
    },
  },
  methods: {
    dialogDateSelected(date) {
      this.$refs.dialog.save(date);
    },
  },
};
</script>

<style></style>
